function VoteUs() {
  return (
    <div className="bg-blue-900 py-16 md:py-24 text-center">
      <h2 className="text-5xl font-black text-white">Volte č. 3</h2>
    </div>
  );
}

export default VoteUs;
